import { Reveal } from "./Reveal";
import GoHighLevelForm from "./GoHighLevelForm";

// An elegant, brand-grounded wrapper that places a header above a GHL form.
export default function FormFrame({ overline, title, subtitle, formId, formName, height, testId }) {
  return (
    <div data-testid={`${testId}-wrapper`} className="mx-auto w-full max-w-2xl">
      {(overline || title) && (
        <Reveal className="mb-8 text-center">
          {overline && <span className="overline text-gold">{overline}</span>}
          {title && (
            <h3 className="mt-4 font-serif text-3xl md:text-4xl font-light tracking-tight text-navy">
              {title}
            </h3>
          )}
          {subtitle && <p className="mt-4 text-navy/60 font-light">{subtitle}</p>}
          <span className="mx-auto mt-6 block h-px w-16 bg-gold/60" />
        </Reveal>
      )}
      <Reveal delay={0.1}>
        <GoHighLevelForm formId={formId} formName={formName} height={height} testId={testId} />
      </Reveal>
    </div>
  );
}
